var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.content),function(address,index){return _c('div',{key:index,staticClass:"config-viewer-address-item"},[_c('span',{staticClass:"config-viewer-address-item--id muted"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('ui-address',{attrs:{"address":address,"hide-name":true}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }